import { render, staticRenderFns } from "./AppModalShare.vue?vue&type=template&id=f2b54660&"
import script from "./AppModalShare.vue?vue&type=script&lang=js&"
export * from "./AppModalShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports